<script>
import { getShadowColor, getFileTypeLogo } from '@/utils/modules/getStyles'
import { getFileType, imgPathFn } from '@/utils/common.js'

export default {
  name: 'FileBox',
  props: {
    type: {
      type: Number,
      default: 3 // 1-图文 2-图片 3-文件
    },
    headline: {
      type: String,
      default: ''
    },
    filename: {
      type: String,
      default: ''
    },
    createtime: {
      type: String,
      default: ''
    },
    cover: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, getFileTypeLogo, getFileType, imgPathFn,
    imgFilter(img) {
      return img ? imgPathFn(img) : require('imgs/modules/default-cover.webp')
    }
  }
}
</script>

<template>
  <div class="item file-item pointer" :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}">
    <el-image
      class="file-img"
      :src="type === 3 ? getFileTypeLogo(filename) : imgFilter(cover)"
      alt="file"
      fit="cover"
    />
    <div class="item-right">
      <p class="name h-line-1">{{ headline }}</p>
      <!-- <p class="file-type">文件格式: {{ getFileType(filename) }}</p> -->
      <p class="file-type">{{ createtime | formatDate('yyyy-MM-dd') }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.file-item {
  width: 340px;
  height: 91px;
  background: #fff;
  border-radius: 5px;
  padding: 15px;

  display: flex;
  align-items: center;
  box-sizing: border-box;
  .file-img {
    width: 57px;
    height: 61px;
    border-radius: 5px;
  }
  .item-right {
    height: 77px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    margin-left: 20px;
    .name {
      font-size: 13px;
      font-weight: 600;
      color: #000;
    }
    .file-type {
      font-size: 10px;
      font-weight: 600;
      color: var(--grey-text-color);
    }
  }
}
</style>
